import { connect } from 'react-redux';
import ErrorHandler from '../../../components/PageStructure/ErrorHandler/ErrorHandler';
import { defaultConfig } from '../../../settings/errorSettings';
import { dismissGlobalError } from '../../../actions/global';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('error');

function getErrorMessage(message) {
  let errorMessage;
  let translatable = false;
  let errorParameters = [];
  if (typeof message === 'string') {
    // In case of general JS errors, the message is generally a string describing the error
    errorMessage = message;
  } else if (typeof message === 'object' && message.translationKey) {
    // This should be the most common scenario, a translatable API error
    errorMessage = message.translationKey;
    errorParameters = message.parameters;
    translatable = true;
  } else if (message === null || typeof message === 'undefined') {
    // Show a generic error message if, for some obscure reason,
    // the message was empty and errorShown was set to false
    errorMessage = locale.getMsg('undefinedError');
  } else {
    try {
      // Fallback, try to turn whatever the message was into a string
      errorMessage = message.toString();
    } catch (err) {
      // Receiving an error that's not empty and cannot be turned into a string
      // really shouldn't happen, but just in case
      errorMessage = err;
    }
  }
  return { errorMessage, translatable, errorParameters };
}

const mapStateToProps = ({
  global: {
    errors: { lastError },
  },
}) => {
  const { message, duration = defaultConfig.duration, timeStamp, errorShown } = lastError || {};
  const { errorMessage, translatable, errorParameters } = getErrorMessage(message);
  return {
    errorMessage,
    errorParameters,
    errorDuration: duration,
    errorShown,
    translatable,
    timeStamp,
  };
};

const mapDispatchToProps = dispatch => ({
  dismissError: () => dispatch(dismissGlobalError()),
});

const ErrorHandlerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorHandler);

export default ErrorHandlerContainer;
